import { AppShell } from '@mantine/core';
import { ReactNode } from 'react';
import { HeaderBar } from '../header/header';

type MenuDrivenContainerProps = {
  children: ReactNode;
  header?: string | ReactNode;
};

export const MenuDrivenContainerNoNavbar = ({ children, header }: Partial<MenuDrivenContainerProps>) => {
  return (
    <AppShell
      layout="alt"
      header={{ height: 52 }}
      padding={16}
      withBorder={false}
      transitionDuration={0}
      style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}
      styles={{
        main: {
          flex: 1,
          overflowY: 'auto',
          minHeight: 0,
          transition: 'padding-right 0.3s ease',
          height: 'calc(100vh - 52px)',
        },
      }}
    >
      <HeaderBar header={header} />
      <AppShell.Main>{children}</AppShell.Main>
    </AppShell>
  );
};
